import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithoutAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithoutAuthWithoutBody
} from "../../APIHelpers/Responses";

function getRuntimeConfig() {
  const w = typeof window !== "undefined" ? window : null;
  const runtime = (w && w.SitePilotChatWidgetConfig) ? w.SitePilotChatWidgetConfig : {};
  return { ...config, ...runtime };
}

export const inboxServices = {
  addNewVisitor,
  addNewInbox,
  updateInboxSession,
  sendInboxMessage,
  softDeleteRestoreInbox,
  deleteInbox,
  deleteSession,
  getInboxList,
  getSingleInbox,
  getSingleVisitor,
  getSingleInboxSessionList,
  getConversationBasedonInboxId,
  getTimelineBasedonContact,
  getTimelineHistory,
  getNotificationByCustomer,
  getDashboardTrackingCount
};

async function addNewVisitor(userData) {
  const cfg = getRuntimeConfig();
  const response = await fetch(
    `${cfg.API_URL_USER_ONBOARDING}addNewVisitor`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  return decryptResponse(result);
}

async function addNewInbox(userData) {
  const cfg = getRuntimeConfig();
  const response = await fetch(
    `${cfg.API_URL_USER_ONBOARDING}addNewInbox`,
    headersWithoutAuth("POST", userData)
  );
  const result = await response.json();
  return decryptResponse(result);
}

async function updateInboxSession(userData) {
  const cfg = getRuntimeConfig();
  const response = await fetch(
    `${cfg.API_URL_USER_ONBOARDING}updateInboxSession`,
    headersWithoutAuth("PUT", userData)
  );
  const result = await response.json();
  return decryptResponse(result);
}

async function sendInboxMessage(userData) {
  const cfg = getRuntimeConfig();
  const response = await fetch(
    `${cfg.API_URL_USER_ONBOARDING}sendInboxMessage`,
    headersWithoutAuth("PUT", userData)
  );
  const result = await response.json();
  return decryptResponse(result);
}

// Soft Delete Inbox
async function softDeleteRestoreInbox(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreInbox`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  return data;
}

// Delete Inbox
async function deleteInbox(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteInbox`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Session
async function deleteSession(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteSession`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Inbox
async function getInboxList(inboxType, type, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getInboxList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getInboxList/${inboxType}/${type}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getInboxList/${inboxType}/${type}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Inbox
async function getSingleInbox(inboxId, sessionId) {
  try {
    const signal = cancelPreviousRequest(`getSingleInbox/${inboxId}/${sessionId}`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleInbox/${inboxId}/${sessionId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Visitor
async function getSingleVisitor(propertyId, deviceFingerprint) {
  try {
    const signal = cancelPreviousRequest(`getSingleVisitor`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleVisitor/${propertyId}/${deviceFingerprint}`
    const response = await fetch(apiURL, {
      ...headersWithoutAuthWithoutBody("GET"),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Inbox Session List
async function getSingleInboxSessionList(inboxId) {
  try {
    const signal = cancelPreviousRequest(`getSingleInboxSessionList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleInboxSessionList/${inboxId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Inbox Session List
async function getConversationBasedonInboxId(inboxId) {
  try {
    const signal = cancelPreviousRequest(`getConversationBasedonInboxId`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getConversationBasedonInboxId/${inboxId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Inbox Session List
async function getTimelineBasedonContact(propertyId, contactId, inboxId) {
  try {
    const signal = cancelPreviousRequest(`getTimelineBasedonContact`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getTimelineBasedonContact/${propertyId}/${contactId}/${inboxId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Timeline History
async function getTimelineHistory(propertyId, contactId, inboxId, uniqueId, type) {
  try {
    const signal = cancelPreviousRequest(`getTimelineHistory`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getTimelineHistory/${propertyId}/${contactId}/${inboxId}/${uniqueId}/${type}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Total Notification By Customer
async function getNotificationByCustomer(inboxId) {
  try {
    const signal = cancelPreviousRequest(`getNotificationByCustomer`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getNotificationByCustomer/${inboxId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Dashboard Tracking Count
async function getDashboardTrackingCount() {
  try {
    const signal = cancelPreviousRequest(`getDashboardTrackingCount`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getDashboardTrackingCount`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}